import { useEffect, useState } from 'react';
import { MdLaptop, MdOutlinePhoneAndroid } from 'react-icons/md';
import { Box, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import {
  Area,
  AreaChart,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { useAppSelector } from '../../../redux/hooks';
import { getAppAnalytics } from '../../../redux/viewApp/appAnalytics/selectors';
import { fetchAppLogsFromPastYear } from '../../../utils/app-analytics/fetch-logs';

export const AppChart = () => {
  const appAnalytics = useAppSelector(getAppAnalytics);
  const [appLogs, setAppLogs] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const appLogData = await fetchAppLogsFromPastYear(appAnalytics.appDetail.appId);
      setAppLogs(appLogData);
    };

    // fetchData();
  }, []);

  return (
    <Box width="100%" borderRadius="16px" mt="30px" bgColor="#F7F9FB" boxShadow="2px">
      <VStack align="flex-start" padding={6} w="100%" h="100%" spacing="30px">
        <VStack align="flex-start" w="100%" spacing={4}>
          <Text
            color="black"
            className="small-font"
            style={{ fontWeight: 650 }}
            whiteSpace="pre-line"
            fontWeight="bold"
            fontFamily="inter"
          >
            App Details
          </Text>
          <HStack w="100%" justifyContent="flex-start">
            <Text
              color="gray"
              w="20%"
              className="x-small-font"
              whiteSpace="pre-line"
              fontFamily="inter"
            >
              Application Name
            </Text>
            <HStack alignItems="flex-start" spacing={4} w="80%">
              <Text
                color="black"
                className="x-small-font"
                whiteSpace="pre-line"
                fontFamily="inter"
              >
                {appAnalytics?.appDetail?.name}
              </Text>
              <Icon
                as={
                  appAnalytics?.appDetail?.appType === 'MOBILE'
                    ? MdOutlinePhoneAndroid
                    : MdLaptop
                }
              >
                <Tooltip label="Application Type" />
              </Icon>
            </HStack>
          </HStack>
          {appAnalytics.appDetail?.description && (
            <HStack w="100%" justifyContent="flex-start">
              <Text
                color="gray"
                w="20%"
                className="x-small-font"
                whiteSpace="pre-line"
                fontFamily="inter"
              >
                Application Description
              </Text>
              <Text
                color="black"
                w="80%"
                className="x-small-font"
                noOfLines={1}
                whiteSpace="pre-line"
                fontFamily="inter"
              >
                {appAnalytics.appDetail.description}
              </Text>
            </HStack>
          )}
          {appAnalytics.appDetail?.projectName && (
            <HStack w="100%" justifyContent="flex-start">
              <Text
                color="gray"
                w="20%"
                className="x-small-font"
                whiteSpace="pre-line"
                fontFamily="inter"
              >
                Project Name
              </Text>
              <Text
                color="black"
                w="80%"
                className="x-small-font"
                whiteSpace="pre-line"
                fontFamily="inter"
              >
                {appAnalytics.appDetail.projectName}
              </Text>
            </HStack>
          )}
          <HStack w="100%" justifyContent="flex-start">
            <Text
              color="gray"
              w="20%"
              className="x-small-font"
              whiteSpace="pre-line"
              fontFamily="inter"
            >
              Application Secret
            </Text>
            <Text
              color="black"
              w="80%"
              className="x-small-font"
              whiteSpace="pre-line"
              fontFamily="inter"
            >
              Application Secret is visible only at the time of creating the application
            </Text>
          </HStack>
        </VStack>

        <VStack align="flex-start" w="100%" spacing="16px">
          <Text
            color="black"
            className="small-font"
            style={{ fontWeight: 650 }}
            whiteSpace="pre-line"
            fontWeight="bold"
            fontFamily="inter"
          >
            Claims
          </Text>
          <VStack w="100%" h={appLogs?.length ? '24vh' : '4vh'}>
            {appLogs?.length ? (
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart
                  data={appLogs}
                  margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
                >
                  <defs>
                    <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#00000066" stopOpacity={0.2} />
                      <stop offset="95%" stopColor="#00000066" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid
                    horizontal={true}
                    vertical={false}
                    strokeDasharray="1 1"
                  />
                  <Area
                    type="monotone"
                    dataKey="totalClaims"
                    stroke="#00000066"
                    strokeWidth={1.5}
                    fillOpacity={1}
                    fill="url(#colorGradient)"
                  />
                  <XAxis tickMargin={10} dataKey="date" />
                  <YAxis />
                  <Tooltip />
                </AreaChart>
              </ResponsiveContainer>
            ) : (
              <>
                <VStack spacing={1}>
                  <Text color="black" mt={1} className="medium-font" fontFamily="inter">
                    No claim data available
                  </Text>
                  <Text color="gray" className="xx-small-font" fontFamily="inter">
                    Claim Chart is updated every 24 hours
                  </Text>
                </VStack>
              </>
            )}
          </VStack>
        </VStack>
      </VStack>
    </Box>
  );
};
